import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';

@Injectable()
export class HeaderService {
    // As our URL is accessed through IFrame which is an external content for
    // angular application. So, we need to bypass security trust check using
    // DOM Sanitizer in order to display content for our URL.
    constructor(
        private observableRequest: ObservableRequestService,
        private domSanitizer: DomSanitizer,
    ) { }

    // Method to limit the length of a string if it is more that a specified limit.
    limitDisplayName(stringValue: string, limitLength: number): any {

        // Initialize return value.
        let strReturnValue = '';
        // If string is more that specified character, limit it.
        if (stringValue.length >= limitLength) {
            strReturnValue = stringValue.substr(0, limitLength);
            strReturnValue = strReturnValue + '..';
        } else {
            strReturnValue = stringValue;
        }
        return strReturnValue;
    }
}



// WEBPACK FOOTER //
// ./src/app/header/header.service.ts